export default "__VITE_ASSET__CIFjqyTJ__"